import { Component, OnInit } from '@angular/core';

import {environment} from '../../../../../environments/environment';
import { AuthRESTService } from "../../../services/rest/auth-rest.service";
import { HeaderWidget } from "../../../widgets/header/header.component";
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import Commons from 'app/components/pages/commons';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MetaPropertySchema } from '../../../../models/metaPropertySchema';
import { debounceTime, Subscription } from 'rxjs';
import { SharedModule } from 'app/shared.module';
import { AppWidgetModule } from 'app/components/widgets/widget.module';

@Component({
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.css'],
  standalone: true,
  imports: [SharedModule, AppWidgetModule]
})
export class UsersPage extends Commons implements OnInit {
	loginableUserProperty: string;
    users: Array<any> = [];
    usersPerPage: number;
    userToDelete: string;
    firstUserOnFirstPage: any;
    lastUser: any;
    firstUser: any;
    router: Router;
    showBackButton: boolean = true;
    showNextButton: boolean = true;
    homeLink: string;
    backLink: string;
	forwardLink: string;
	currentState:  string = "initial" //"loading", "initial", "loaded"
	propNamesToReturn: string[] = [
		"primary_email", "username", "first_name", "name"
	];
	propsToReturn: Array<MetaPropertySchema> = []; // gets inflated by propNamesToReturn
	propNamesToSearch: string[] = ["primary_email", "name", "username"];
	propsToSearch: Array<MetaPropertySchema> = []; // gets inflated by propNamesToSearch
	params: any = {
		searchTerm: '',
		itemsOnPage: 10,
		nrPage: 1,
		propertyIdsToSearch: null,
		propertiesToReturn: [],
		asc: true
	};
	pages: number [] = [];
	totalResultItemsCount: number = 0;
	minCharactersToStartSearch: number = 4;
	selectedUser: any;

    constructor(private rest: AuthRESTService, private route: ActivatedRoute,
        toastr: ToastrService, translate: TranslateService, router: Router) {
        super(toastr, translate)
		this.rest = rest;
		this.router = router;
		if (!environment.systemCode) return;
		if (environment.systemCode === "SV") {
			this.propNamesToReturn.push("NIT", "DUI");
			this.propNamesToSearch.push("NIT", "DUI");
		}
		if (environment.systemCode === "GT") {
			this.propNamesToReturn.push("NIT", "DPI");
			this.propNamesToSearch.push("NIT", "DPI");
		}
    }

    userVerificationMessage(user) {
        return HeaderWidget.getVerificationMessage(user.userVerified, user.emailVerified)
    }

    showVerificationWarning(user) {
        return HeaderWidget.showVerificationWarning(user.userVerified, user.emailVerified)
    }

    deleteUser(user, userDeletingConfirmModal, e) {
    	e.preventDefault();
    	e.stopPropagation();
		this.selectedUser = user;
		userDeletingConfirmModal.show();
	}

	getUsers() {
		this.route.paramMap.pipe(debounceTime(1000)).subscribe(params => {
			let searchTerm = params.get('searchTerm');

			this.params.searchTerm = searchTerm || '';
			this.params.propertyIdsToSearch = this.propsToSearch.map((prop) => { return prop.id; });
			if (!searchTerm) {
				this.currentState = "initial";
				this.users = [];
				return;
			}
			if (searchTerm.length < this.minCharactersToStartSearch) return;
			this.currentState = "loading";
			this.rest.post('manager/userList', this.params).subscribe((response) => {
				this.currentState = "loaded";
				this.totalResultItemsCount = response.count;
				this.users = [];
				response.users.forEach((userData) => {
					let result = {
						id: userData.id,
						userVerified: userData.verified,
						values: []
					};
					this.propsToReturn.forEach((prop) => {
						if (!userData.properties.some((userProp) => {
							if (userProp.id === prop.id) {
								result.values.push(userProp.values[0].value);
								return true;
							}
						})) {
							result.values.push("-");
						}
					});
					this.users.push(result);
				});
			}, err => {
				this.errorHandler(err);
				this.currentState = "loaded";
			});
		});
	}

    ngOnInit() {
		this.rest.get('cas/configuration/property').subscribe((response) => {
			response.forEach((prop) => {
				this.propNamesToReturn.forEach((propName, idx) => {
					if (propName === prop.name) {
						this.propsToReturn[idx] = Object.assign(new MetaPropertySchema(this.translate), prop, { display: (prop.display && JSON.parse(prop.display)) });
						this.params.propertiesToReturn.push(prop.id);
					}
				});
				this.propNamesToSearch.forEach((propName, idx) => {
					if (propName === prop.name) {
						this.propsToSearch[idx] = Object.assign(new MetaPropertySchema(this.translate), prop, { display: (prop.display && JSON.parse(prop.display)) });
					}
				});
			});

			this.getUsers();
		});
    }


    convertToDateTime(isoDate: string) {
        return new Date(isoDate).toLocaleString()
	}

	setParam(paramName, val: any) {
		this.params[paramName] = val.target.value;
		this.updateRoute();
	}

	updateRoute() {
		this.router.navigate(['users',  Object.assign({}, this.route.snapshot.paramMap, this.params)]);
	}

	setupBindToCasModalDefault(): void {
		this.loginableUserProperty = this.params.searchTerm || '';
	}

	bindToCAS(ev, bindToCASModal): void {
		this.rest.get('manager/adduser/' + this.loginableUserProperty).subscribe((res) => {
			this.router.navigate(['/user/' + res.id + '/edit']);
			bindToCASModal.hide();
		}, err => {
			this.errorHandler(err)
		});
	}

	confirmDelete(user, userDeletingConfirmModal) {
		this.rest.delete(`manager/user/${user.id}`).subscribe((res) => {
			userDeletingConfirmModal.hide();
			this.getUsers();
		}, err => {
			this.errorHandler(err)
		});
	}
}
